import { render, staticRenderFns } from "./clueDetail.vue?vue&type=template&id=72c2c4f0&scoped=true&"
import script from "./clueDetail.vue?vue&type=script&lang=js&"
export * from "./clueDetail.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaDetails/mediaDetails.less?vue&type=style&index=0&id=72c2c4f0&lang=less&scoped=true&"
import style1 from "./clueDetail.vue?vue&type=style&index=1&id=72c2c4f0&lang=less&scoped=true&"
import style2 from "./clueDetail.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c2c4f0",
  null
  
)

component.options.__file = "clueDetail.vue"
export default component.exports